import AlertFinishSession from "@components/page-wrapper/header-practititoner/alert-finish-session";
import { useCallback, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { logout as kcLogout, getUser, renewToken } from "@functions/auth";
import useCleanRedux from "./clean-redux/use-clean-redux";

export default function useInactivityTime( minutes: number ) {
    const [openAlert, setOpenAlert] = useState<boolean>(false);
    const { cleanReducers } = useCleanRedux();
    const { start, reset } = useIdleTimer({
        onPrompt: () => setOpenAlert(true),
        onIdle: () => logout(),
        timeout: 60000 * (minutes - 1),
        promptTimeout: 90000,
        events: [
            "mousemove",
            "keydown",
            "wheel",
            "DOMMouseScroll",
            "mousewheel",
            "mousedown",
            "touchstart",
            "touchmove",
            "MSPointerDown",
            "MSPointerMove",
            "visibilitychange"
        ],
        element: document,
        startOnMount: true,
    });
    
    const logout = async () => {
        cleanReducers();
        setOpenAlert(false);
        await kcLogout();
    };

    const renewTokenInactive = async () => {
        await renewToken();
        const res = await getUser();
        if(res){
            window.sessionStorage.setItem("auth-token", res.access_token);
            window.sessionStorage.setItem("refresh-token", res.refresh_token || "a");
            window.sessionStorage.setItem("expires", res.expires_at?.toString() || "0");
        }
    };

    const resetTimer = useCallback(() => {     
        renewTokenInactive();
        setOpenAlert(false);
        reset();
        start();
    }, [reset, start]);

    const alertFinish = () => AlertFinishSession({open: openAlert, onClose: resetTimer, action: () => logout()});

    return [alertFinish];
};